import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../view/Home";
import Weblogs from "../view/Weblogs";
import InternalWeblog from "../view/InternalWeblog";
import Gallery from "../view/Gallery";
import Photos from "../view/Photos";
import PartnersParticular from "../view/PartnersParticular";
import Contact from "../view/Contact";
import AboutUs from "../view/AboutUs";
import files from "../view/files";
import Videos from "../view/Videos";
import Voices from "../view/Voices";
import page from "../view/page";
import partnerList from "../view/partnerList"
Vue.use(VueRouter);

const routes = [{
        path: '/',
        component: Home
    },
    {
        path: '/weblogs',
        name: "weblogs",
        component: Weblogs
    },
    {
        path: '/partner-list',
        name: "partnerList",
        component: partnerList
    },
    {
        path: '/gallery',
        name: "gallery",
        component: Gallery
    },
    {
        path: '/internal-Weblog/:id/:slug?',
        name: "weblogDetail",
        component: InternalWeblog
    },
    {
        path: '/photos',
        name: "photos",
        component: Photos
    },
    {
        path: '/videos',
        name: "videos",
        component: Videos
    },
    {
        path: '/files',
        name: "files",
        component: files
    },
    {
        name: "voices",
        path: '/voices',
        component: Voices
    },
    {
        path: '/partners',
        name: "partners",
        component: PartnersParticular
    },
    {
        path: '/contact',
        name: "contactUs",
        component: Contact
    },
    {
        path: '/page/:id',
        name: "page",
        component: page
    },
    {
        path: '/about-us',
        name: "aboutUs",
        component: AboutUs
    },

]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        window.scrollTo(0, 0)
            // ...
    },
    routes
})

export default router;